export default "__VITE_ASSET__BpZN4RjM__"